import { PopoverProps } from '@fluentui/react-components';
import { FC, ReactNode } from 'react';
import PopoverCallout from './PopoverCallout';

export interface ICalloutIconProps {
    icon: ReactNode;
    buttonAriaLabel?: string;
    children?: ReactNode;
    onDismiss?: () => void;
    /** Optional dark callout surface (replaces Fluent 8 getCalloutProps styling). */
    darkSurface?: boolean;
    /** Positioning for the Popover surface. */
    positioning?: PopoverProps['positioning'];
    /** Extra class on PopoverSurface. */
    surfaceClassName?: string;
    /** When false, do not trap focus. Default true. */
    trapFocus?: boolean;
}

/**
 * Thin CalloutIcon wrapper over the shared F0.1 PopoverCallout host.
 * Public props stay close to the prior API; Fluent 8 Callout/Link/ICalloutProps are gone.
 */
const CalloutIcon: FC<ICalloutIconProps> = ({
    icon,
    buttonAriaLabel = '',
    children,
    onDismiss,
    darkSurface,
    positioning,
    surfaceClassName,
    trapFocus,
}) => {
    return (
        <PopoverCallout
            icon={icon}
            buttonAriaLabel={buttonAriaLabel}
            onDismiss={onDismiss}
            darkSurface={darkSurface}
            positioning={positioning}
            surfaceClassName={surfaceClassName}
            trapFocus={trapFocus}
        >
            {children}
        </PopoverCallout>
    );
};

export default CalloutIcon;
